import { useGetCompaniesQuery } from '../services/companies.service';

type UseCompaniesProps = {
  search?: string;
  page: number;
  pageSize: number;
};

const useCompanies = ({ search, page, pageSize }: UseCompaniesProps) => {
  const { data, isLoading, error } = useGetCompaniesQuery({
    search,
    paginated: { page, pageSize },
  });

  return {
    isLoading,
    error,
    companies: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
  };
};

export default useCompanies;
